"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _ykbUtils = require("ykb-utils");
var _default2 = _interopRequireDefault(require("../locales/default"));
var _classnames = _interopRequireDefault(require("classnames"));
var _LocaleContext = require("../locales/LocaleContext");
var _Spin = _interopRequireDefault(require("../Spin"));
var _base_ = _interopRequireWildcard(require("./base_12.1.2"));
var _TemplateOption = _interopRequireDefault(require("./TemplateOption"));
var _excluded = ["mode", "notFoundContent", "className", "loading", "placeholder", "template", "size", "prefixCls", "renderTemplate", "showSearch", "getPopupContainer", "allowTurkishSearch", "showCursor", "editableCurrency", "scroll"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint no-console: 0 */ // import RcSelect, { OptGroup, Option } from 'rc-select';
var Select = /*#__PURE__*/function (_React$Component) {
  function Select(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Select);
    _this = _callSuper(this, Select, [props]);
    _this.onSearch = _this.onSearch.bind(_this);
    _this.onSelect = _this.onSelect.bind(_this);
    _this.state = {
      searchText: ''
    };
    return _this;
  }
  (0, _inherits2.default)(Select, _React$Component);
  return (0, _createClass2.default)(Select, [{
    key: "onSelect",
    value: function onSelect(value, option) {
      this.setState({
        searchText: ''
      });
      if (this.props.onSelect) {
        this.props.onSelect(value, option);
      }
    }
  }, {
    key: "onSearch",
    value: function onSearch(searchText) {
      this.setState({
        searchText: searchText
      });
      if (this.props.onSearch) {
        this.props.onSearch(searchText);
      }
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(theme) {
      var _this2 = this;
      var _this$props = this.props,
        data = _this$props.data,
        children = _this$props.children,
        loading = _this$props.loading,
        valueKey = _this$props.valueKey,
        labelKey = _this$props.labelKey,
        template = _this$props.template,
        renderTemplate = _this$props.renderTemplate,
        multiColumnTagLabelKey = _this$props.multiColumnTagLabelKey,
        allowTurkishSearch = _this$props.allowTurkishSearch;
      var finalData = loading ? [] : data;
      //TODO: Daha guzel yazilabilir
      if (finalData) {
        return finalData.map(function (option, index) {
          var $$data = '';
          if (renderTemplate) {
            $$data = option[multiColumnTagLabelKey];
            return /*#__PURE__*/_react.default.cloneElement(renderTemplate(option), {
              $$data: $$data,
              $$tooltip: option
            });
          }
          if (option.data) {
            return /*#__PURE__*/_react.default.createElement(_base_.OptGroup, {
              key: index,
              label: option[labelKey]
            }, _this2.renderOptionGroup(option.data));
          }
          if (template && valueKey) {
            $$data = option[multiColumnTagLabelKey || labelKey];
            return /*#__PURE__*/_react.default.createElement(_base_.Option, (0, _extends2.default)({}, option, {
              value: option[valueKey],
              key: option[valueKey]
            }), /*#__PURE__*/_react.default.createElement(_TemplateOption.default, (0, _extends2.default)({}, _this2.props, {
              theme: theme,
              searchText: _this2.state.searchText,
              option: option,
              $$data: $$data,
              allowTurkishSearch: allowTurkishSearch
            })));
          }
          return /*#__PURE__*/_react.default.createElement(_base_.Option, (0, _extends2.default)({}, option, {
            value: option[valueKey],
            key: option[valueKey]
          }), option[labelKey]);
        });
      } else {
        return children;
      }
    }
  }, {
    key: "renderOptionGroup",
    value: function renderOptionGroup(data) {
      var _this$props2 = this.props,
        valueKey = _this$props2.valueKey,
        labelKey = _this$props2.labelKey;
      return data.map(function (option) {
        return /*#__PURE__*/_react.default.createElement(_base_.Option, (0, _extends2.default)({}, option, {
          value: option[valueKey],
          key: option[valueKey]
        }), option[labelKey]);
      });
    }
  }, {
    key: "renderNotFound",
    value: function renderNotFound() {
      var _this$props3 = this.props,
        notFoundContent = _this$props3.notFoundContent,
        loading = _this$props3.loading;
      if (loading) {
        return /*#__PURE__*/_react.default.createElement(_Spin.default, {
          spinning: true,
          text: ""
        });
      } else if (notFoundContent === undefined) {
        return 'Sonuç bulunamadı';
      } else {
        return notFoundContent;
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.selectRef) {
        console.log(this.selectRef);
        // this.selectRef.focus();
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      if (this.selectRef) {
        this.selectRef.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props4 = this.props,
        mode = _this$props4.mode,
        notFoundContent = _this$props4.notFoundContent,
        className = _this$props4.className,
        loading = _this$props4.loading,
        placeholder = _this$props4.placeholder,
        template = _this$props4.template,
        size = _this$props4.size,
        prefixCls = _this$props4.prefixCls,
        renderTemplate = _this$props4.renderTemplate,
        showSearch = _this$props4.showSearch,
        getPopupContainer = _this$props4.getPopupContainer,
        allowTurkishSearch = _this$props4.allowTurkishSearch,
        showCursor = _this$props4.showCursor,
        editableCurrency = _this$props4.editableCurrency,
        scroll = _this$props4.scroll,
        restProps = (0, _objectWithoutProperties2.default)(_this$props4, _excluded);
      if (!(0, _ykbUtils.isNullOrUndefined)(template)) {
        restProps['dropdownClassName'] = ["".concat(prefixCls, "-template"), restProps['dropdownClassName']].join(' ');
      }
      var cls = (0, _classnames.default)(className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-lg"), !!prefixCls && size === 'large'), "".concat(prefixCls, "-sm"), !!prefixCls && size === 'small'), "".concat(prefixCls, "-multiple"), restProps.multiple), "".concat(prefixCls, "-template"), !!prefixCls && !(0, _ykbUtils.isNullOrUndefined)(template)), "showCursor", !!showCursor));
      var isCombobox = mode === 'combobox';
      var _this$props5 = this.props,
        optionLabelProp = _this$props5.optionLabelProp,
        optionFilterProp = _this$props5.optionFilterProp,
        filterOption = _this$props5.filterOption,
        multiColumnTagType = _this$props5.multiColumnTagType,
        maxTagCount = _this$props5.maxTagCount;
      optionFilterProp = optionFilterProp || 'children';
      var customFilterFn = function customFilterFn(input, option) {
        if (optionFilterProp == 'children' && option.props && (0, _typeof2.default)(option.props[optionFilterProp]) === 'object') {
          var status = false;
          var object = option.props;
          for (var key in object) {
            if (object.hasOwnProperty(key) && !(!(0, _ykbUtils.isNullOrUndefined)(template) && key == template['avatarUrlLabelKey'])) {
              var value = object[key];
              if (typeof value === 'string') {
                status = allowTurkishSearch ? (0, _ykbUtils.compareLowerCase)(input, value) : (0, _ykbUtils.toTurkishLowerCase)(value).indexOf((0, _ykbUtils.toTurkishLowerCase)(input)) >= 0;
                if (status) break;
              }
            }
          }
          // Object.keys(option.props).forEach(element => {
          //   let _value = option.props[element];
          //   if (typeof _value == 'string' && !status) {
          //     status = this.toTurkishLowerCase(_value).indexOf(this.toTurkishLowerCase(input)) >= 0;
          //   }
          // });
          return status;
        }
        var source = option.props ? option.props[optionFilterProp] : option[optionFilterProp];
        if (source) return allowTurkishSearch ? (0, _ykbUtils.compareLowerCase)(input, source) : (0, _ykbUtils.toTurkishLowerCase)(source).indexOf((0, _ykbUtils.toTurkishLowerCase)(input)) >= 0;
        return false;
      };
      var filterFn = filterOption || customFilterFn;
      if (filterOption === false) filterFn = false;
      if (isCombobox) {
        optionLabelProp = optionLabelProp || 'value';
      } else {
        optionLabelProp = optionLabelProp || 'children';
      }
      if (renderTemplate) {
        multiColumnTagType = multiColumnTagType == 'caption' ? 'firstColumn' : multiColumnTagType || 'firstColumn';
      } else if (template) {
        multiColumnTagType = multiColumnTagType == 'firstColumn' ? 'caption' : multiColumnTagType || 'caption';
      }
      var modeConfig = {
        multiple: mode === 'multiple',
        showSearch: showSearch || mode === 'multiple' || mode === 'tags',
        tags: mode === 'tags',
        combobox: isCombobox,
        template: template,
        multiColumnTagType: multiColumnTagType,
        maxTagCount: multiColumnTagType === 'count' ? 0 : maxTagCount,
        scroll: scroll
      };
      var popupContainer = getPopupContainer ? getPopupContainer : function (node) {
        return (0, _ykbUtils.containerChecker)(node);
      };
      return /*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleReceiver, {
        componentName: "Select",
        defaultLocale: _default2.default.Select
      }, function (localeCode, locale) {
        return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
          return /*#__PURE__*/_react.default.createElement(_base_.default, (0, _extends2.default)({
            getPopupContainer: popupContainer,
            mode: mode
          }, restProps, {
            ref: function ref(node) {
              _this3.selectRef = node;
              if (restProps.ref) {
                restProps.ref(node);
              }
            }
          }, modeConfig, {
            prefixCls: prefixCls,
            className: cls,
            notFoundContent: _this3.renderNotFound(),
            optionLabelProp: optionLabelProp,
            optionFilterProp: optionFilterProp,
            placeholder: placeholder || locale.placeholder,
            filterOption: filterFn,
            onSearch: _this3.onSearch,
            onSelect: _this3.onSelect,
            theme: theme,
            size: size,
            dropdownRender: _this3.props.renderExtraFooter,
            dropdownRenderHeader: _this3.props.renderExtraHeader,
            dropdownClassName: editableCurrency ? 'editable-currency' : '',
            allowClear: _this3.props.allowClear,
            showCursor: _this3.props.showCursor,
            locale: locale
          }), _this3.renderOptions(theme));
        });
      });
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(Select, "Option", _base_.Option);
(0, _defineProperty2.default)(Select, "OptGroup", _base_.OptGroup);
(0, _defineProperty2.default)(Select, "defaultProps", {
  showSearch: false,
  validationItem: true,
  allowClear: false,
  showCursor: false,
  className: '',
  disabled: false,
  multiLine: false,
  labelInValue: false,
  valueKey: 'value',
  labelKey: 'label',
  tooltipOptions: {
    hiddenLabels: []
  },
  allowTurkishSearch: false,
  dropdownMatchSelectWidth: true,
  scroll: true
});
(0, _defineProperty2.default)(Select, "propTypes", {
  size: _propTypes.default.oneOf(['default', 'large', 'small']),
  mode: _propTypes.default.string,
  notFoundContent: _propTypes.default.any,
  optionLabelProp: _propTypes.default.string,
  optionFilterProp: _propTypes.default.string,
  loading: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  disabled: _propTypes.default.bool,
  multiLine: _propTypes.default.bool,
  showSearch: _propTypes.default.bool,
  labelInValue: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  renderExtraFooter: _propTypes.default.object,
  renderExtraHeader: _propTypes.default.object,
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string
  })),
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
  allowClear: _propTypes.default.bool,
  showCursor: _propTypes.default.bool,
  valueKey: _propTypes.default.string,
  labelKey: _propTypes.default.string,
  template: _propTypes.default.shape({
    columnHeaders: _propTypes.default.arrayOf(_propTypes.default.string),
    captionLabelKeys: _propTypes.default.arrayOf(_propTypes.default.string),
    columnLabelKeys: _propTypes.default.arrayOf(_propTypes.default.string),
    avatarUrlLabelKey: _propTypes.default.string
  }),
  renderTemplate: _propTypes.default.func,
  tooltipOptions: _propTypes.default.shape({
    renderToolTip: _propTypes.default.func,
    hiddenLabels: _propTypes.default.array
  }),
  onSearch: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  multiColumnTagType: _propTypes.default.oneOf(['caption', 'firstColumn', 'count']),
  multiColumnTagLabelKey: _propTypes.default.string,
  /**
   * Shows all select option only for multiple mode
   */
  showSelectAll: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
  /**
   * Allows recordings that are not within the selection.
   */
  autoAdd: _propTypes.default.bool,
  /**
   * Allows searching with Turkish characters.
   */
  allowTurkishSearch: _propTypes.default.bool,
  /**
   * A function to format copied text.
   */
  copyFormatter: _propTypes.default.func,
  /**
   * Setting dropdown to match select width or not.
   */
  dropdownMatchSelectWidth: _propTypes.default.bool,
  backgroundColorType: _propTypes.default.oneOf(['primary', 'danger']),
  /**
   * Setting scroll prop to false also closes virtual scroll feature.
   */
  scroll: _propTypes.default.bool
});
var _default = exports.default = Select; // export default class Select extends React.Component {
//   static Option = Option;
//   static OptGroup = OptGroup;
//   render() {
//     return (
//       <LocaleReceiver
//         componentName="Select"
//         defaultLocale={defaultLocale.Select}
//       >
//         {(localeCode, locale) => (
//           <ThemeConsumer>
//             {theme => <RcSelect {...this.props} theme={theme}></RcSelect>}
//           </ThemeConsumer>
//         )}
//       </LocaleReceiver>
//     );
//   }
// }